var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_circle_fill_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check_circle_fill_svg__ds",
    x1: 42.78,
    y1: 215,
    x2: 387.22,
    y2: 215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m215,387.22c-94.96,0-172.22-77.26-172.22-172.22,0-22.3,4.21-44.01,12.5-64.52h0c12.71-31.44,34.26-58.25,62.31-77.52,28.74-19.74,62.42-30.18,97.41-30.18,94.96,0,172.22,77.26,172.22,172.22s-77.26,172.22-172.22,172.22ZM66.4,154.98h0,0Z",
    style: {
      fill: "url(#check_circle_fill_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.53,296.86c-3.02,0-6.04-1.13-8.36-3.39-.29-.28-29.11-28.31-57.47-56.55-4.7-4.68-4.71-12.28-.03-16.97,4.68-4.69,12.28-4.71,16.97-.03,19.14,19.07,38.5,38.03,49.08,48.37,24.43-22.83,96.2-90.25,131.52-127.21.09-.1.22-.23.35-.37,4.45-4.91,12.04-5.29,16.95-.84,4.91,4.45,5.29,12.04.84,16.95-.24.27-.49.53-.74.8-43.29,45.3-139.96,135.15-140.93,136.05-2.3,2.14-5.24,3.21-8.17,3.21Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFill);
export default __webpack_public_path__ + "static/media/check_circle_fill.05a75b7a21744e9fb7bc89dcd4744c5a.svg";
export { ForwardRef as ReactComponent };